var fontSize = 14;
var htmlFontSize = 16;
var coef = (fontSize / 14);
function pxToRem(size) {
    return "".concat((size / htmlFontSize) * coef, "rem !important");
}
export { pxToRem };
